import {Translatable} from 'common/i18n';
import {getMultiAttributionFromEntry} from 'common/query-builder/query-builder/util';
import {MultiAttribution} from 'common/widgets/multi-attribution-menu/types';
import {AttributionTypeToSpec} from 'common/widgets/multi-attribution-menu/constants';
import {MultiAttributionType} from 'common/types/reports/bookmark';

import {Entry, isMetricEntry} from '../types';

export function getMultiAttributionLabel(entry: Entry, isMenuOpen: boolean): Translatable {
  const multiAttribution = getMultiAttributionFromEntry(entry);
  if (multiAttribution) {
    return multiAttribution.type === MultiAttributionType.Custom
      ? (multiAttribution.name as string)
      : AttributionTypeToSpec[multiAttribution.type].label;
  } else {
    // We only want to show the placeholder text if it's open AND the user
    // doesn't have a selected attribution type already
    if (isMenuOpen) {
      return ({t}) => t(`query-builder.value-placeholder`);
    }
    return ``;
  }
}

export function getMultiAttributionTitle(entry: Entry): Translatable {
  const multiAttribution = getMultiAttributionFromEntry(entry);
  if (multiAttribution) {
    return AttributionTypeToSpec[multiAttribution.type].description;
  }
  return ``;
}

export function getUpdatedMultiAttribution(entry: Entry, multiAttribution: MultiAttribution): Entry {
  return isMetricEntry(entry)
    ? {...entry, measurement: {...entry.measurement, multiAttribution}}
    : ({...entry, multiAttribution} as Entry);
}
